import { ThreadMessageWithThreadData } from '@hb/shared'
import { useMemo } from 'react'
import { useMe } from '../../hooks/auth/useMe'
import { populateThreadMessage } from '../utils'

export const usePopulatedMessage = (message: ThreadMessageWithThreadData) => {
  const me = useMe()

  return useMemo(
    () => populateThreadMessage(me?.uid ?? null, message, undefined, undefined),
    [me, message],
  )
}
